// /apps/integrations から /software/registry への変更の影響で /software/integrations に遷移しないように、暫定でリダイレクトを置いておく
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_staff/software/_layout/integrations")({
  beforeLoad: ({ location }) => {
    const newPathname = "/software/registry";

    // クエリパラメータも引き継ぐ
    const searchParams = new URLSearchParams(location.search);
    const search = searchParams.toString();
    const to = search ? `${newPathname}?${search}` : newPathname;

    throw redirect({ to });
  },
});
